/** @jsxImportSource @emotion/react */

import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
}

/**
 * Две искры — большая и малая: значок ИИ (кнопка «ИИ-ассистент» в шапке).
 *
 * Красится `currentColor`, поэтому цвет задаёт вызывающая сторона (`text-*` или `color`). `viewBox`
 * подогнан под границы самой фигуры, так что значок по центру своей рамки.
 */
function SparklesIcon(props: IProps) {
  const { ...rest } = props;

  return (
    <svg width="20" height="20" viewBox="12.64 9 20.37 20.37" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.0002 9C30.2088 9.00008 30.4122 9.06539 30.5818 9.18679C30.7514 9.30819 30.8789 9.47959 30.9462 9.677L31.2962 10.703L32.3232 11.053C32.5208 11.1204 32.6923 11.2478 32.8138 11.4176C32.9352 11.5873 33.0005 11.7908 33.0005 11.9995C33.0005 12.2082 32.9352 12.4117 32.8138 12.5814C32.6923 12.7512 32.5208 12.8786 32.3232 12.946L31.2972 13.296L30.9472 14.323C30.8799 14.5205 30.7524 14.6921 30.5827 14.8135C30.4129 14.935 30.2094 15.0003 30.0007 15.0003C29.792 15.0003 29.5885 14.935 29.4188 14.8135C29.2491 14.6921 29.1216 14.5205 29.0542 14.323L28.7042 13.297L27.6772 12.947C27.4797 12.8796 27.3082 12.7522 27.1867 12.5824C27.0652 12.4127 26.9999 12.2092 26.9999 12.0005C26.9999 11.7918 27.0652 11.5883 27.1867 11.4186C27.3082 11.2488 27.4797 11.1214 27.6772 11.054L28.7032 10.704L29.0532 9.677C29.1207 9.47943 29.2482 9.30791 29.4181 9.1865C29.5879 9.06509 29.7915 8.99987 30.0002 9ZM20.1072 12.448C20.7242 10.643 23.2772 10.643 23.8932 12.448L24.6992 14.808C24.8967 15.3864 25.2241 15.9118 25.6562 16.344C26.0884 16.7761 26.6138 17.1035 27.1922 17.301L29.5522 18.107C31.3572 18.724 31.3572 21.277 29.5522 21.893L27.1922 22.699C26.6138 22.8965 26.0884 23.2239 25.6562 23.656C25.2241 24.0882 24.8967 24.6136 24.6992 25.192L23.8932 27.552C23.2762 29.357 20.7232 29.357 20.1072 27.552L19.3012 25.192C19.1039 24.6137 18.7766 24.0884 18.3446 23.6562C17.9127 23.224 17.3874 22.8966 16.8092 22.699L14.4492 21.893C12.6432 21.276 12.6432 18.723 14.4492 18.107L16.8092 17.301C17.387 17.1035 17.9119 16.7763 18.3437 16.3445C18.7755 15.9127 19.1027 15.3878 19.3002 14.81L20.1072 12.448Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SparklesIcon;
